import { gql } from 'graphql-request'

// Mutation to update corporate custom integration
export const updateCorporateCustomThirdPartyIntegrationMutation = gql`
  mutation UpdateCorporateCustomThirdPartyIntegration(
    $corporateId: String!
    $input: UpdateCorporateCustomThirdPartyIntegrationInput!
  ) {
    updateCorporateCustomThirdPartyIntegration(corporateId: $corporateId, input: $input) {
      id
      customIntegrations {
        integrationId
        keyValues {
          key
          value
        }
      }
    }
  }
`

// Legacy mutation - keeping for backwards compatibility
export const setCorporateUserCorporateCustomIntegrationMutation = gql`
  mutation SetCorporateUserCorporateCustomIntegration(
    $keys: [AddCustomIntegrationKeyValueInput!]!
    $integrationId: String!
  ) {
    setCorporateUserCorporateCustomIntegration(keys: $keys, integrationId: $integrationId) {
      id
    }
  }
`

// Mutation to update ClassPass integration
export const updateCorporateClassPassMutation = gql`
  mutation UpdateCorporateClassPass($corporateId: String!, $siteIds: [String!]!) {
    updateCorporateClassPass(corporateId: $corporateId, siteIds: $siteIds) {
      corporateId
      integrations {
        classPass {
          siteIds
        }
      }
    }
  }
`
